import {
  CellEditorOverrideProvider,
  CellFormatOverrideProvider,
  CellViewRendererOverrideProvider,
  type CellEditorOverride,
  type CellFormatOverride,
  type CellViewRendererOverride,
} from "@platform/btx-plan-designer";
import { AgGridReact } from "ag-grid-react";

import { PlanEditorContent } from "./PlanEditorContent";

import type { PlanEditorContentProps } from "./PlanEditorContent";

// ---------------------------------------------------------------------------
// Plan editor panel — layers the active cell-editor/view-renderer/format
// overrides around PlanEditorContent. Extracted to keep Quotes' render below
// the complexity limit.
// ---------------------------------------------------------------------------

interface QuotesPlanEditorPanelProps extends PlanEditorContentProps {
  gridRef: React.Ref<AgGridReact>;
  cellEditorOverride: CellEditorOverride;
  cellViewRendererOverride: CellViewRendererOverride | null;
  cellFormatOverride: CellFormatOverride | null;
}

export const QuotesPlanEditorPanel = ({
  gridRef,
  cellEditorOverride,
  cellViewRendererOverride,
  cellFormatOverride,
  ...planEditorProps
}: QuotesPlanEditorPanelProps): React.JSX.Element => {
  let editor = <PlanEditorContent ref={gridRef} {...planEditorProps} />;

  editor = (
    <CellEditorOverrideProvider override={cellEditorOverride}>
      {editor}
    </CellEditorOverrideProvider>
  );

  if (cellViewRendererOverride) {
    editor = (
      <CellViewRendererOverrideProvider override={cellViewRendererOverride}>
        {editor}
      </CellViewRendererOverrideProvider>
    );
  }

  if (cellFormatOverride) {
    editor = (
      <CellFormatOverrideProvider override={cellFormatOverride}>
        {editor}
      </CellFormatOverrideProvider>
    );
  }

  return editor;
};
